import React, { useState, useEffect } from "react";
import { Menu, Button, MenuProps } from "antd";
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";

interface Props {
  course: any;
}

const MenuSlider: React.FC<Props> = ({ course }) => {
const navigate = useNavigate()
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const [openKeys, setOpenKeys] = useState<string[]>([]);

  const data = course?.sections ?? [];
  const firstChapter = data[0];
  const firstSequence = firstChapter?.children?.[0];
  const firstUnit = firstSequence?.children?.[0];

  useEffect(() => {
    if (firstChapter && firstSequence && firstUnit) {
      setOpenKeys([
        `chapter-${firstChapter.id}`,
        `sequence-${firstSequence.id}`,
      ]);
      setSelectedKeys([`unit-${firstUnit.id}`]);
      navigate(`${location.pathname}?unitId=${firstUnit.id}`);
    }
  }, [course]);

  const menuItems: MenuProps["items"] = data.map((chapter: any) => ({
    key: `chapter-${chapter.id}`,
    label: chapter.name,
    children: chapter.children?.map((sequence: any) => ({
      key: `sequence-${sequence.id}`,
      label: sequence.name,
      children: sequence.children?.map((unit: any) => ({
        key: `unit-${unit.id}`,
        label: unit.name,
        onClick: () => {
          navigate(`${location.pathname}?unitId=${unit?.id}`);
        },
      })),
    })),
  }));

  return (
    <div
      className="discussion-course-slider"
      style={{ width: collapsed ? 80 : "24%" }}>
      <Button
        onClick={() => setCollapsed(!collapsed)}
        style={{ marginBottom: 8 }}
        className="toggle-btn"
      >
        {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
      </Button>
      {!collapsed &&
        <Menu
          mode="inline"
          inlineCollapsed={collapsed}
          items={menuItems}
          selectedKeys={selectedKeys}
          openKeys={openKeys}
          onOpenChange={(keys) => setOpenKeys(keys)}
          onSelect={({ key }) => setSelectedKeys([key])}
        />
      }

    </div>
  );
};

export default MenuSlider;
